export const MOBILE_TEXT_INPUT_HEIGHT = 20
export const DESKTOP_TEXT_INPUT_HEIGHT = 44
